import { render, staticRenderFns } from "./StatusOrderItem.vue?vue&type=template&id=68286e40&"
import script from "./StatusOrderItem.vue?vue&type=script&lang=js&"
export * from "./StatusOrderItem.vue?vue&type=script&lang=js&"
import style0 from "./StatusOrderItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports